const corretorFields = [
  {
    id: "NOME_CORRETOR",
    label: "Nome do corretor",
    type: "text",
    required: true,
  },
  {
    id: "NACIONALIDADE_CORRETOR",
    label: "Nacionalidade",
    type: "text",
    required: true,
  },
  {
    id: "CPF_CORRETOR",
    label: "CPF",
    type: "text",
    required: true,
    mask: "cpf",
  },
  { id: "RG_CORRETOR", label: "RG", type: "text", required: true },
  {
    id: "CRECI_CORRETOR",
    label: "CRECI",
    type: "text",
    required: true,
  },
  {
    id: "RUA_ENDERECO_CORRETOR",
    label: "Rua",
    type: "text",
    required: true,
  },
  {
    id: "N_ENDERECO_CORRETOR",
    label: "Número",
    type: "text",
    required: true,
  },
  {
    id: "BAIRRO_ENDERECO_CORRETOR",
    label: "Bairro",
    type: "text",
    required: true,
  },
  {
    id: "MUN_ENDERECO_CORRETOR",
    label: "Município",
    type: "text",
    required: true,
  },
  {
    id: "CEP_CORRETOR",
    label: "CEP",
    type: "text",
    required: true,
  },
  {
    id: "EMAIL_CORRETOR",
    label: "E-mail",
    type: "email",
    required: true,
  },
  {
    id: "TEL_CORRETOR",
    label: "Telefone",
    type: "text",
    required: true,
    mask: "phone",
  },
];

const contratoParceriaVendasFormSchema = [
  {
    sectionId: "captantes",
    sectionLabel: "Parte(s) Captante(s)",
    repeatable: true,
    groupKey: "captantes",
    minItems: 1,
    maxItems: 1,
    fields: [...corretorFields],
  },
  {
    sectionId: "intermediadores",
    sectionLabel: "Parte(s) Intermediador(es)",
    repeatable: true,
    groupKey: "intermediadores",
    minItems: 1,
    maxItems: 1,
    fields: [...corretorFields],
  },
  {
    sectionId: "testemunhas",
    sectionLabel: "Testemunhas",
    repeatable: true,
    groupKey: "testemunhas",
    fields: [
      { id: "NOME_TESTEMUNHA", label: "Nome", type: "text", required: true },
      {
        id: "CPF_TESTEMUNHA",
        label: "CPF",
        type: "text",
        required: true,
        mask: "cpf",
      },
      { id: "EMAIL_TESTEMUNHA", label: "Email", type: "email", required: true },
    ],
  },
  {
    sectionId: "dados-contrato",
    sectionLabel: "Dados do contrato",
    fields: [
      {
        id: "DESCRICAO_PRODUTO",
        label: "Descrição do produto",
        type: "text",
        required: true,
      },
      {
        id: "COMISSAO_INTERMEDIADOR",
        label: "Comissão do intermediador (%)",
        type: "text",
        required: true,
        mask: "decimal_br",
      },
      {
        id: "MULTA_CONTRATUAL",
        label: "Multa contratual",
        type: "text",
        required: true,
      },
      {
        id: "FORO",
        label: "Foro (comarca)",
        type: "text",
        required: true,
      },
      {
        id: "CIDADE_ASSINATURA",
        label: "Cidade da assinatura",
        type: "text",
      },
      {
        id: "DATA_ASSINATURA",
        label: "Data da assinatura",
        type: "date",
      },
    ],
  },
];

export default contratoParceriaVendasFormSchema;
